import { AllocatorPage } from '@/components/dealCatalog-page/allocator-page';
import { SeekingInterestPage } from '@/components/dealCatalog-page/seekingInterest-page';
import { InvestorInterestPage } from '@/components/dealPipeline-page/investorInterest';
import { AuthLayout } from '@/layouts/authLayout';
import { DashboardLayout } from '@/layouts/dashboard/dashboard-layout';
import {
  ActiveInvestmentsPage,
  AllCommitmentPlansPage,
  AllManagerUpdatesPage,
  AllocationHistoryPage,
  ChangePasswordPage,
  CompliancePage,
  DataIntegrityPage,
  DealCatalogPage,
  DealPipelinePage,
  DownloadDealDocumentsPage,
  DueDiligenceHistoryPage,
  EditCommitmentPlanPage,
  EditInvestorPage,
  EditManagerUpdatePage,
  EditStrategyDescriptionPage,
  ForwardDealDocumentsPage,
  GenerateSignaturePacketPage,
  GenericError,
  InvestorDetailsPage,
  InvestorsPage,
  ManagerSignatureExpiredPage,
  ManagerSpotlightWizardPage,
  ManagerUpdatesPage,
  ModifyStrategyPage,
  PendingCommitmentsPage,
  ProfilePage,
  SendDealDocumentsTrackingPage,
  SettingsPage,
  StrategyDetailsPage,
  ToDoPage,
  TransactionDetailsPage,
  TransactionsPage,
  TwoFactorAuthenticationPage,
  VerifyEmailChangePage
} from '@/pages';
import Login from '@/pages/Auth/LoginPage';
import PasswordRecovery from '@/pages/Auth/PasswordRecovery';
import ReportingDataPage from '@/pages/ReportingData';
import { RouteObject } from 'react-router-dom';
import DealRegistryPage from '../pages/DealRegistry';
import DueDiligencePage from '../pages/DueDiligence';
import DueDiligenceRecordPage from '../pages/DueDiligence/Record';
import ModifyDiligencePage from '../pages/DueDiligence/modify';
import { PrivateRoute } from './PrivateRoute';

export const routes: RouteObject[] = [
  {
    element: <AuthLayout />,
    children: [
      {
        path: '/',
        element: <Login />
      },
      {
        path: '/login',
        element: <Login />
      },
      {
        path: '/password-recovery',
        element: <PasswordRecovery />
      },
      {
        path: '/two-factor-authentication',
        element: <TwoFactorAuthenticationPage />
      },
      {
        path: '/change-password',
        element: <ChangePasswordPage />
      },
      {
        path: '/verify-email-change',
        element: <VerifyEmailChangePage />
      }
    ]
  },
  {
    path: '/download-deal-documents',
    element: <DownloadDealDocumentsPage />
  },
  {
    path: '/manager-signature-expired',
    element: <ManagerSignatureExpiredPage />
  },
  {
    element: (
      <PrivateRoute>
        <DashboardLayout />
      </PrivateRoute>
    ),
    children: [
      {
        path: '/deal/:strategyId',
        element: <StrategyDetailsPage />
      },
      {
        path: '/strategyDetails/:strategyId',
        element: <StrategyDetailsPage />
      },
      {
        path: '/strategyDetails/editStrategyDescription/:strategyId',
        element: <EditStrategyDescriptionPage />
      },
      {
        path: '/strategyDetails/:strategyId/allUpdates/edit/:updateId',
        element: <EditManagerUpdatePage />
      },
      {
        path: '/strategyDetails/:strategyId/allUpdates',
        element: <AllManagerUpdatesPage />
      },
      {
        path: '/todo',
        element: <ToDoPage />
      },
      {
        path: '/dealCatalog',
        element: <DealCatalogPage />
      },
      {
        path: '/dealCatalog/allocator/:id',
        element: <AllocatorPage />
      },
      {
        path: '/dealCatalog/seekingInterest/:id',
        element: <SeekingInterestPage />
      },
      {
        path: '/dealPipeline',
        element: <DealPipelinePage />
      },
      {
        path: '/dealPipeline/modify',
        element: <ModifyStrategyPage />
      },
      {
        path: '/dealPipeline/:id/:name',
        element: <InvestorInterestPage />
      },
      {
        path: '/dealPipeline/allocator/:id',
        element: <AllocatorPage />
      },
      {
        path: '/dealPipeline/managerSpotlightWizard',
        element: <ManagerSpotlightWizardPage />
      },
      {
        path: '/investors',
        element: <InvestorsPage />
      },
      {
        path: '/investors/create-investor',
        element: <EditInvestorPage />
      },
      {
        path: '/investors/:investorId/:entityId?',
        element: <InvestorDetailsPage />
      },
      {
        path: '/investors/:investorId/:entityId?/edit',
        element: <EditInvestorPage />
      },
      {
        path: '/investors/:investorId/:entityId/editCommitmentPlan',
        element: <EditCommitmentPlanPage />
      },
      {
        path: '/investors/:investorId/:entityId/allCommitmentPlans',
        element: <AllCommitmentPlansPage />
      },
      {
        path: '/dealRegistry',
        element: <DealRegistryPage />
      },
      {
        path: '/dueDiligence',
        element: <DueDiligencePage />
      },
      {
        path: '/dueDiligence/:recordId',
        element: <DueDiligenceRecordPage />
      },
      {
        path: '/dueDiligence/modify',
        element: <ModifyDiligencePage />
      },
      {
        path: '/managerUpdates',
        element: <ManagerUpdatesPage />
      },
      {
        path: '/pendingCommitments',
        element: <PendingCommitmentsPage />
      },
      {
        path: '/pendingCommitments/forwardDealDocuments/:strategyId',
        element: <ForwardDealDocumentsPage />
      },
      {
        path: '/transactions',
        element: <TransactionsPage />
      },
      {
        path: '/transactions/forwardDealDocuments/:strategyId',
        element: <ForwardDealDocumentsPage />
      },
      {
        path: '/transactions/generateSignaturePacket/:allocationId',
        element: <GenerateSignaturePacketPage />
      },
      {
        path: '/transactions/transactionDetails/:allocationId',
        element: <TransactionDetailsPage />
      },
      {
        path: '/activeInvestments',
        element: <ActiveInvestmentsPage />
      },
      {
        path: '/reportingData',
        element: <ReportingDataPage />
      },
      {
        path: '/compliance',
        element: <CompliancePage />
      },
      {
        path: '/compliance/allocationHistory',
        element: <AllocationHistoryPage />
      },
      {
        path: '/compliance/dueDiligenceHistory',
        element: <DueDiligenceHistoryPage />
      },
      {
        path: '/compliance/sendDealDocumentsTracking',
        element: <SendDealDocumentsTrackingPage />
      },
      {
        path: '/compliance/transactionDetails/:allocationId',
        element: <TransactionDetailsPage />
      },
      {
        path: '/compliance/dueDiligence/:recordId',
        element: <DueDiligenceRecordPage />
      },
      {
        path: '/settings',
        element: <SettingsPage />
      },
      {
        path: '/data-integrity',
        element: <DataIntegrityPage />
      },
      {
        path: '/profile',
        element: <ProfilePage />
      },
      {
        path: '*',
        element: <GenericError />
      }
    ]
  }
];
